// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ComponentTitleAmpersandFragmentDoc } from './componentTitleAmpersand.fragment.generated';
import { ComponentTitleTextFragmentDoc } from './componentTitleText.fragment.generated';
export const ComponentTitleComponentFragmentDoc = gql`
    fragment componentTitleComponent on ComponentTitleComponent {
  ... on ComponentTitleAmpersand {
    ...componentTitleAmpersand
  }
  ... on ComponentTitleText {
    ...componentTitleText
  }
}
    ${ComponentTitleAmpersandFragmentDoc}
${ComponentTitleTextFragmentDoc}`;